<template>
  <div class="bb-chart">
    <div class="bb-chart-header">
      <h2 class="bb-chart-header__title">{{title}}</h2>
      <div class="bb-chart-header-total">
        <span class="bb-chart-header-total__today">
          Today -
        </span>
        <ICountUp
          :delay="countUp.delay"
          :endVal="total ? total : 0"
          :options="countUp.options"
        /> AED
      </div>
    </div>
    <chart :options="chartOptions"/>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
import {Chart} from 'highcharts-vue'
import convertNumber from '@/mixin/convertNumber'
import borderRadius from 'highcharts-border-radius'
import ICountUp from 'vue-countup-v2'
borderRadius(Highcharts)

export default {
  name: 'ChartColumn',
  components: {
    Chart,
    ICountUp
  },
  mixins: [convertNumber],
  props: ['data', 'title', 'color', 'total'],
  data () {
    return {
      seriesDataDef: [],
      countUp: {
        delay: 0,
        options: {
          context: this,
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          decimalPlaces: 2
        }
      }
    }
  },
  computed: {
    seriesData: {
      get: function () {
        return this.seriesDataDef
      },
      set: function (data) {
        this.seriesDataDef = data
      }
    },
    chartOptions: function () {
      return {
        chart: {
          type: 'column',
          height: 153
        },
        plotOptions: {
          column: {
            borderRadiusTopLeft: 4,
            borderRadiusTopRight: 4,
            animationLimit: Infinity,
            animation: {
              duration: 1000
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          type: 'category',
          labels: {
            rotation: 0,
            style: {
              color: '#AFAFAF',
              fontSize: '11px',
              fontFamily: 'SF UI Display, sans-serif'
            }
          }
        },
        yAxis: {
          maxPadding: 0,
          gridLineColor: '#EEEEEE',
          title: {
            text: ''
          },
          labels: {
            format: '{value}',
            style: {
              color: '#AFAFAF',
              fontSize: '11px',
              fontFamily: 'SF UI Display, sans-serif'
            }
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          outside: true,
          distance: -2,
          headerFormat: '',
          useHTML: true,
          formatter: function () {
            const pointY = String(this.point.y.toFixed(2)).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            return `<div class="bb-chart-tooltip"><b class="bb-chart-tooltip__num">${pointY}</b>  AED</div>`
          },
          shadow: false,
          borderColor: 'transparent',
          backgroundColor: 'transparent'
        },
        series: [{
          cursor: 'pointer',
          color: this.color,
          data: this.seriesData,
          dataLabels: {
            enabled: false
          },
          animationLimit: Infinity,
          animation: {
            duration: 1000
          }
        }]
      }
    },
    options: {
      get: function () {
        return this.chartOptions
      },
      set: function (data) {
        this.chartOptions.series[0].data = data
      }
    }
  },
  watch: {
    data () {
      this.seriesData = this.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Finance/Dashboard/ChartColumn/ChartColumn.vue